import { combineReducers } from 'redux';
import reports from './reports';
import reportTemplateList from './report-template-list';
import guestList from './guest-list';
import guestSearch from './guest-search';

export default combineReducers({
  reports,
  reportTemplateList,
  guestList,
  guestSearch
});
